import React from 'react'
import { Link } from "react-router-dom";
const NotFound = () => {
  return (
   <>
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 px-4 text-center">
      <h1 className="text-6xl font-bold text-[#EB0A1E] mb-4">404</h1>
      <p className="text-xl font-semibold mb-2">Halaman Tidak Ditemukan</p>
      <p className="text-gray-600 mb-6">Sepertinya halaman yang Anda cari tidak tersedia.</p>
      <Link
        to="/"
        className="inline-block bg-[#EB0A1E] text-white px-5 py-2 rounded-md hover:bg-red-700 transition"
      >
        Kembali ke Beranda
      </Link>
    </div>
   </>
  )
}

export default NotFound
